import get from 'lodash/get'
import api from '@/api'

export const getters = {
  getFeatureEnabledByKey: (state) => (featureKey) =>
    get(state.featuresByKey, [featureKey, 'enabled']),
}

export const actions = {
  async fetchFeatures() {
    const response = await api.fetchFeatures()
    response.features.forEach(({ key, state }) => {
      this.featuresByKey[key] = { key, enabled: state === 'on' }
    })
  },
}
